// extracted by mini-css-extract-plugin
export default {"container":"index_container__Rpc9C","content":"index_content__2NtHl","name":"index_name__l8pHA","desc":"index_desc__uHse3","line":"index_line__Fq5dz"};